import axios from 'axios';
import moment from 'moment/moment';

export default {
    init() {
        // JavaScript to be fired on the dashboard page
        const $nav = $('.account-container .nav-link');
        const $navTab = $('#nav-tab');

        $nav.on('click', (e) => {
            if (window.matchMedia('(max-width: 767px)').matches)  { // breakpoint-sm
                //is mobile
                if(!$navTab.hasClass('mobile-open')) {
                    $navTab.toggleClass('mobile-open');
                    setTimeout( () => {
                        $navTab.toggleClass('animated');
                    }, 100);
                } else {
                    $navTab.toggleClass('animated');
                    setTimeout( () => {
                        $navTab.toggleClass('mobile-open');
                    }, 100);
                }
            }
        });

        //toggle form

        const $btnEdit = $('button.edit');
        const $btnCancel = $('button.cancel');
        const $btnDelete = $('button.btn-delete');
        const $updateForm = $('.update-form');
        const $info = $('.info');

        $btnEdit.on('click', (e) => {
            e.preventDefault();

            const formTarget = $(e.currentTarget).data('target');
            $updateForm.find('.form-section').removeClass('active');
            $updateForm.find('.' + formTarget).addClass('active');

            const $shippingDataRow = $(e.currentTarget).parents('.shipping-data');
            const $shippingDataInputs = $shippingDataRow.find('span');

            if(formTarget === 'info-shipping' && !$shippingDataRow.hasClass('new')) {
                // i have to fill the form with old data
                $('input[name="shipping_address_id"]').val($shippingDataRow.data('shipping-id'));

                $updateForm.find('label').removeClass('text-danger');
                $updateForm.find('small').hide();
                $updateForm.find('input').removeClass('is-invalid');
                $updateForm.find('.btn-delete').show();

                for (let i = 0; i < $shippingDataInputs.length; i++) {
                    let currentClass = $($shippingDataInputs[i]).attr('class');

                    //looking for input or select, this could be extended to others, ex: checkbox, radio
                    let $input = $updateForm.find('input[name="'+currentClass+'"],select[name="'+currentClass+'"]');
                    if($input.length > 0) {
                        $input.val($($shippingDataInputs[i]).html());
                    }
                }

                if($shippingDataInputs.length == 0) {
                    $updateForm.find('.btn-delete').hide();
                }
            } else {

                let $inputs = $('.info-shipping').find('input,select');

                for (let i = 0; i < $inputs.length; i++) {
                    if ($($inputs[i]).is('select')) {
                        $($inputs[i]).prop('selectedIndex', 0);
                    } else {
                        $($inputs[i]).val("");
                    }
                }
            }

            $updateForm.toggleClass('animate-in');
            setTimeout( () => {
                $updateForm.toggleClass('in');
            }, 100);

            $info.toggleClass('in');
            setTimeout( () => {
                $info.toggleClass('animate-in');
            }, 100);

        });

        $btnCancel.on('click', (e) => {
            $updateForm.toggleClass('in');
            setTimeout( () => {
                $updateForm.toggleClass('animate-in');
            }, 100);

            $info.toggleClass('animate-in');
            setTimeout( () => {
                $info.toggleClass('in');
            }, 100);
        });

        $btnDelete.on('click', (e) => {
            e.preventDefault();

            $(e.currentTarget).parents('form').attr('action', window.routeDeleteAddress).submit();

        });


        //load order detail

        const $orderDetailBtn = $('.order-detail');
        const $orderBackBtn = $('.back-to-list');
        const $tableOrderN = $('.table-order-n');
        const $tableOrderDate = $('.table-order-date');
        const $tableOrderPayment = $('.table-order-payment');

        let loading = false;
        $orderDetailBtn.on('click', (e) => {
            e.stopImmediatePropagation();
            e.preventDefault();

            let $orderListCnt = $('.order-list-container');
            let $orderDetailCnt = $(e.currentTarget).parents('.order-list-container').siblings('.order-detail-container');
            let $productsContainer = $orderDetailCnt.find('.products');

            let orderId = $(e.currentTarget).data('order-id');

            if(loading) return;

            $productsContainer.empty();

            if ($(e.currentTarget).hasClass('show-payment-form')) {
                $('.request-param-cart').addClass('d-none');
                $orderDetailCnt.find('#request-param-cart-id-' + orderId).removeClass('d-none');
            }

            $(e.currentTarget).addClass('loading');
            loading = true;
            axios.get(window.routeGetOrderAjax, {
                params: {
                    order_id: orderId
                }
            })
                .then(function (response) {
                    // handle success
                    $tableOrderN.html(response.data.id);
                    if(response.data.bank_timestamp) {
                        $tableOrderDate.html(moment(response.data.bank_timestamp, 'YYYY-MM-DD hh:mm:ss').format('DD-MM-YYYY'));
                    } else if(response.data.created_at) {
                        $tableOrderDate.html(moment(response.data.created_at, 'YYYY-MM-DD hh:mm:ss').format('DD-MM-YYYY'));
                    }
                    $tableOrderPayment.html(response.data.payment);
                    
                    response.data.rows.forEach( cartRow => {
                        console.log(cartRow)
                        let productTemplate =`
                                <div class="product col-12 col-sm-6 col-md-4 col-xl-3">
                                    <h4>${cartRow.name}</h4>
                                    <div class="d-flex flex-row">
                                        <div class="img-container">
                                            <img src="${cartRow.imageUrl}" alt="" />
                                        </div>
                                        <div class="d-flex flex-column justify-content-center">
                                            <span>${window.PRODUCT.qty}: ${cartRow.qty}</span>
                                            <span>${window.PRODUCT.color}: ${cartRow.color_name}</span>
                                            <span>${window.PRODUCT.size}: ${cartRow.size_name}</span>
                                            <span>EUR: ${cartRow.price}</span>
                                        </div>
                                    </div>
                                </div>`;

                        $productsContainer.append(productTemplate);
                    });

                    $orderListCnt.toggleClass('animate-in');
                    setTimeout( () => {
                        $orderListCnt.toggleClass('in');
                    }, 100);

                    $orderDetailCnt.toggleClass('animate-in');
                    setTimeout( () => {
                        $orderDetailCnt.toggleClass('in');
                    }, 100);

                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
                .then(function () {
                    // always executed
                    $(e.currentTarget).removeClass('loading');
                    loading = false;
                });

        });

        $orderBackBtn.on('click', (e) => {
            let $orderDetailCnt = $(e.currentTarget).parents('.order-detail-container');
            let $orderListCnt = $('.order-list-container');

            $orderDetailCnt.toggleClass('animate-in');
            setTimeout( () => {
                $orderDetailCnt.toggleClass('in');
            }, 100);

            $orderListCnt.toggleClass('animate-in');
            setTimeout( () => {
                $orderListCnt.toggleClass('in');
            }, 100);

        });

        //prevent double submit form
        const $buttonsSubmit = $('button[type="submit"]');

        $buttonsSubmit.on('click', e => {
            $(e.currentTarget).attr('disabled', true);
            $(e.currentTarget).parents('form').submit();
        });

        //

        const $cancelPendingOrderBtn = $('.cancel-pending-order');
        let loadingCancel = false;
        $cancelPendingOrderBtn.on('click', e => {
            e.preventDefault();

            let orderId = $(e.currentTarget).data('pending-order-id');

            if(loadingCancel) return;

            $(e.currentTarget).addClass('loading');
            loading = true;

            axios.get(window.cancelPendingOrderAjax, {
                params: {
                    order_id: orderId
                }
            })
            .then(function (response) {
                // handle success
                if(response.data) {
                    window.location = window.location;
                }

            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
                $(e.currentTarget).removeClass('loading');
                loadingCancel = false;
            });
        });


    },
    finalize() {
        // JavaScript to be fired on the home page, after the init function


    },
};
